<template>
  <div class="config-dialog">
    <Modal v-model="openConfigDialog" :footer-hide="true">
      <div class="configDialog-wrapper">
        <h2>Config</h2>
        <div class="title-config-wrapper">
          <p>Name</p>
          <input class="value-input" type="text">
        </div>
        <div class="value-config-wrapper">
          <p>Value</p>
          <textarea class="value-input">a</textarea>
        </div>
        <div class="btn-wrapper">
          <button>保存</button>
          <button>取消</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openConfigDialog: false,
    };
  },
  methods: {
    open(data) {
      console.log({ data });
      this.openConfigDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.configDialog-wrapper {
  width: 100%;
  h2{
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  .title-config-wrapper {
    width: 100%;
    margin-bottom: 20px;
    p {
      font-size: 16px;
    }
    input {
      width: 100%;
      margin-top: 20px;
      background-color: transparent;
      outline: none;
      border-bottom: 1px solid #fff;
      padding-bottom: 5px;
    }
  }
  .value-config-wrapper {
    width: 100%;
    p {
      font-size: 16px;
    }
    textarea {
      width: 100%;
      margin-top: 20px;
      background-color: transparent;
      outline: none;
      border-bottom: 1px solid #fff;
      padding-bottom: 5px;
    }
  }
  .btn-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    button{
      margin-top: 30px;
      width: 45%;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #fff;
    }
  }
}
</style>